<ng-container>
  <!-- ROOT: klickbar + icon + expandable -->
  <a
    *ngIf="root && item.visible !== false"
    (click)="itemClick($event)"
    (mouseenter)="onMouseEnter()"
    [ngClass]="item.class"
    tabindex="0"
    pRipple
    [pTooltip]="item.label"
    tooltipStyleClass="menu-tooltip-white"
    [tooltipDisabled]="!(isCompact() && !isHorizontal() && root && !active)"
  >
    <i *ngIf="isPiIcon(item.icon)" class="layout-menuitem-icon" [ngClass]="item.icon"></i>
    <i-tabler *ngIf="!isPiIcon(item.icon)" class="layout-menuitem-icon" [name]="item.icon || 'folder'" />
    <span class="layout-menuitem-text label-small text-inherit whitespace-nowrap overflow-hidden text-ellipsis">{{ item.label }}</span>
    <i-tabler name="chevron-down" class="layout-submenu-toggler" *ngIf="item.items" [class.toggler-rotated]="active" />
  </a>

  <!-- NON-ROOT: external/toggler -->
  <a
    *ngIf="!root && (!item.routerLink || item.items) && item.visible !== false"
    [attr.href]="item.url"
    (click)="itemClick($event)"
    (mouseenter)="onMouseEnter()"
    [ngClass]="item.class"
    [attr.target]="item.target"
    tabindex="0"
    pRipple
    [pTooltip]="item.label"
    tooltipStyleClass="menu-tooltip-white"
    [tooltipDisabled]="!(isCompact() && !isHorizontal() && root && !active)"
  >
    <i *ngIf="isPiIcon(item.icon)" class="layout-menuitem-icon" [ngClass]="item.icon"></i>
    <i-tabler *ngIf="!isPiIcon(item.icon)" class="layout-menuitem-icon" [name]="item.icon || 'folder'" />
    <span class="layout-menuitem-text label-small text-inherit whitespace-nowrap overflow-hidden text-ellipsis">{{ item.label }}</span>
    <i-tabler name="chevron-down" class="layout-submenu-toggler" *ngIf="item.items" />
  </a>

  <!-- NON-ROOT: router leaf -->
  <a
    *ngIf="!root && item.routerLink && !item.items && item.visible !== false"
    (click)="itemClick($event)"
    (mouseenter)="onMouseEnter()"
    [ngClass]="item.class"
    [routerLink]="item.routerLink"
    routerLinkActive="active-route"
    [routerLinkActiveOptions]="
      item.routerLinkActiveOptions || {
        paths: 'exact',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored'
      }
    "
    [fragment]="item.fragment"
    [queryParamsHandling]="item.queryParamsHandling"
    [preserveFragment]="item.preserveFragment"
    [skipLocationChange]="item.skipLocationChange"
    [replaceUrl]="item.replaceUrl"
    [state]="item.state"
    [queryParams]="item.queryParams"
    [attr.target]="item.target"
    tabindex="0"
    pRipple
    [pTooltip]="item.label"
    tooltipStyleClass="menu-tooltip-white"
    [tooltipDisabled]="!(isCompact() && !isHorizontal() && root)"
  >
    <i *ngIf="isPiIcon(item.icon)" class="layout-menuitem-icon" [ngClass]="item.icon"></i>
    <i-tabler *ngIf="!isPiIcon(item.icon)" class="layout-menuitem-icon" [name]="item.icon || 'folder'" />
    <span class="layout-menuitem-text label-small text-inherit whitespace-nowrap overflow-hidden text-ellipsis">{{ item.label }}</span>
    <i-tabler name="chevron-down" class="layout-submenu-toggler" *ngIf="item.items" />
  </a>

<ul
  #submenu
  *ngIf="item.items && item.visible !== false"
  [ngClass]="overlaySubmenuMode ? 'layout-root-submenulist z-50' : 'layout-inline-submenu'"
  [@children]="submenuAnimation"
  (@children.done)="onSubmenuAnimated($event)"
>
  <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
    <li app-menuitem [item]="child" [index]="i" [parentKey]="key" [class]="child['badgeClass']"></li>
  </ng-template>
</ul>
</ng-container>
